import ResourceService from "./resource.service";

class AnalyticsService extends ResourceService {
  static get resource() {
    return "admin/analytics";
  }
}
export default AnalyticsService;
